import React from 'react';
import { useCountdown } from './useCountdown';
export function UrgencyBar() {
  const {
    hours,
    minutes,
    seconds
  } = useCountdown(24);
  return <div className="sticky top-0 z-50 w-full bg-badges-dorado text-fondo-principal py-2 px-4 text-center text-sm font-semibold shadow-md" data-id="element-206">
      ⏰ Precio de lanzamiento — cierra en: {hours}:{minutes}:{seconds}
    </div>;
}